//Proofed
import LanguageIcon from '@mui/icons-material/Language'
import SearchIcon from '@mui/icons-material/Search'
import TuneIcon from '@mui/icons-material/Tune'
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone'
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder'
import HistoryIcon from '@mui/icons-material/History'
import InsightsIcon from '@mui/icons-material/Insights'
import BusinessIcon from '@mui/icons-material/Business'
import DateRangeIcon from '@mui/icons-material/DateRange'
import ContactMailIcon from '@mui/icons-material/ContactMail'
import { AWARDS_NUM, CONTRACT_NUM, TENDER_NUM } from './common'
import { homeStepMail, homeStepQualify, homeStepSearch } from './HomeContent'

export const coreHIWTitle = "How Core Works"
export const coreHIWSubtitle = "Three steps from signup to never missing a relevant tender again"

export const coreSteps = [
    homeStepSearch,
    homeStepMail,
    homeStepQualify
]

export const features = [
    {
        Icon: LanguageIcon,
        title: 'All UK & Ireland Portals',
        body: 'We monitor Find a Tender and 200+ local authority and sector-specific portals automatically, 24/7',
    },
    {
        Icon: NotificationsNoneIcon,
        title: 'Daily Alert at 8:45am',
        body: 'A personalised digest of everything new that matches your saved searches lands in your inbox every morning. Never start the day without knowing what\'s out there',
    },
    {
        Icon: HistoryIcon,
        title: 'Award History Database',
        body: `Search ${AWARDS_NUM} historical contract awards in UK & Ireland. See every tender awarded in your sector over the last 12 months and exactly who won it`,
    },
    {
        Icon: InsightsIcon,
        title: 'Competitor Intelligence',
        body: 'Search by keyword or company name to see who is winning work in your market. Understand typical contract values and which buyers they work with',
    },
    {
        Icon: BusinessIcon,
        title: 'Supplier Profiles',
        body: 'Drill into any supplier to see their award growth, which contract frameworks they sit on and who else competes in the same categories',
    },
    {
        Icon: DateRangeIcon,
        title: 'Framework Tracker',
        body: 'See when government frameworks open and close with a visual timeline. Know exactly when to start conversations with buyers so you never miss the window',
    },
    {
        Icon: BookmarkBorderIcon,
        title: 'Buyer Behaviour Analysis',
        body: 'Look up any public sector buyer, like the Home Office, to see their spending patterns, tender volumes, contract values and who is currently winning their work',
    },
    {
        Icon: ContactMailIcon,
        title: 'Procurement Contact Information',
        body: 'Surface the contact details of the people behind the tenders. Know who to speak to before you bid and ask the right questions at the right time',
    },
]

export const highlights = [
    `${TENDER_NUM} Contracts Live and Historical`,
    '40% of Tenders not published on Find a Tender',
    'Urgent Tenders in your inbox fast',
    'Works alongside Tender Ninja & CFP Analytics',
    'Monthly subscription, cancel anytime',
]


export const faqs = [
    {
        q: 'How is CFP Core different from Find a Tender?',
        a: 'Find a Tender only covers a subset of UK public sector tenders. CFP Core monitors more than 200 portals including Find a Tender and hundreds of local authority portals. Over 40% of tenders you could bid for are never published on Find a Tender',
    },
    {
        q: 'How quickly do alerts arrive after a tender is published?',
        a: 'Your daily digest lands at 8:45am each morning with everything new from the previous 24 hours. For time-sensitive opportunities we also send flash email alerts as soon as a tender is detected, so you can act immediately',
    },
    {
        q: 'Does it cover my sector?',
        a: 'CFP covers all UK & Ireland public sector categories construction, IT, professional services, facilities management, healthcare, education, defence and more. You set the keywords and filters that match your business and we surface only what is relevant to you',
    },
    {
        q: 'What are contract frameworks and why do they matter?',
        a: 'Frameworks are pre-approved supplier lists that government buyers use to procure without running a full tender each time. Once a framework closes, you can\'t get on it until it reopens sometimes years later. CFP\'s framework tracker shows you when they\'re ending so you know exactly when to apply',
    },
    {
        q: 'We already find tenders for free why pay for CFP?',
        a: 'Finding tenders for free is possible but the hidden cost is time and missed coverage. Manually checking 12+ portals every day takes hours and over 40% of tenders are never published on Find a Tender at all. CFP replaces that manual effort with one daily email and adds competitor and buyer intelligence that free tools simply don\'t offer',
    },
    {
        q: 'We don\'t have time for a complex setup.',
        a: 'Setup takes minutes you enter keywords, set your region and contract value range and CFP does the rest. From that point on, everything comes to you. Our support team can also provide an onboarding session to make sure your filters are tuned before you go live',
    },
    {
        q: 'Can I trial CFP Core before committing?',
        a: 'Yes you get a full 14-day free trial with access to every feature. A credit card is required to activate the trial but you won\'t be charged until the trial period ends. Cancel anytime, no questions asked',
    },
]

export const comparison = [
    { feature: 'Number of Portals Covered', cfp: '200+', finder: '1' },
    { feature: 'Coverage of UK Tenders', cfp: '100%', finder: '~60%' },
    { feature: 'Daily Email Digest', cfp: true, finder: true },
    { feature: 'Flash Alerts for Urgent Tenders', cfp: true, finder: false },
    { feature: 'Tender History Database', cfp: `${TENDER_NUM}`, finder: 'Limited' },
    { feature: 'Award History Database', cfp: `${AWARDS_NUM}`, finder: 'Limited' },
    { feature: 'Competitor Intelligence', cfp: true, finder: false, tooltip: 'See which suppliers are winning contracts in your target markets, how much they are winning and from which buyers so you know exactly who you are up against before you bid' },
    { feature: 'Supplier Profiles', cfp: true, finder: false, tooltip: 'Detailed profiles on any UK public sector supplier showing their award history, total contract value, active sectors and key buyer relationships.' },
    { feature: 'Buyer Behaviour Analysis', cfp: true, finder: false, tooltip: 'Understand how individual buyers procure what they buy, how frequently, at what values and through which routes. Helps you tailor your approach before a tender is published' },
    { feature: 'Framework Tracker', cfp: true, finder: false, tooltip: 'Frameworks are pre-approved supplier lists used by government buyers to contract without a full tender. CFP tracks when they open and close so you never miss a window to get on one' },
    { feature: 'Procurement Contact Details', cfp: true, finder: false, tooltip: 'Direct contact details for procurement officers at key buying organisations so you can build relationships with the right people before a competition opens' },
]
